<template>
  <footer class="grid-container full container last">
    <div id="footer-pre" class="grid-container">
      <div class="grid-x grid-padding-x grid-padding-y">
        <div class="cell large-3 text-center">
          <img
            src="@/assets/images/logo-bottom-text.png"
            class="logo-center padding-top-1"
            style="max-height:9.6rem;"
          />
        </div>
        <div class="cell large-9">
          <div class="grid-x grid-padding-y">
            <div class="cell large-6">
              <div class="grid-x">
                <div class="cell large-6">
              <ul class="menu vertical">
                <li class="menu-text text-uppercase h5">
                  Menu
                </li>
                <li class="">
                  <router-link :to="{name: 'home'}">
                    Home
                  </router-link>
                </li>
                <li class="">
                  <router-link :to="{name: 'about'}">
                    About Us
                  </router-link>
                </li>
                <li class="">
                  <router-link :to="{name: 'contact'}">
                    Contact Us
                  </router-link>
                </li>
                
                <!-- <li class="">
                  <router-link :to="{name: 'news'}">
                    News
                  </router-link>
                </li> -->
              </ul>
            </div>
            <div class="cell large-6">
              <ul class="menu vertical">
                <li class="menu-text text-uppercase h5">
                  Categories
                </li>
                <li class="" v-for="(item, index) in menuList" :key="index">
                  <router-link
                    :to="{
                      name: 'catalog',
                      params: { catalog: item.id, entity: item },
                    }"
                    class=""
                  >
                      {{ item.name }}
                  </router-link>
                </li>
              </ul>
            </div>


            <div class="cell large-6">
                  <ul class="menu vertical padding-top-1">
                    <li class="menu-text text-uppercase h5" style="">
                      Follow Us
                    </li>
                    <li class="menu-text" style="font-weight:100;">
                      <div class="grid-x">
                        <div class="cell large-5 padding-bottom-1">
                          <img
                            class=""
                            src="http://gzone1.com/images/9c7c70b8db8a48f199dd92c2a22c58a2.jpg"
                            style="width:3rem;"
                          />
                        </div>
                        <div class="cell large-6">
                          <i
                            class="fi-social-facebook "
                            style="font-size:4rem;    position: relative;
top: -8px;"
                          ></i>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>



              </div>
            </div>
            
            <div class="cell large-6">
              <div class="grid-x">
                <div class="cell">
                  <ul class="menu vertical padding-bottom-1">
                    <li class="menu-text text-uppercase h5">
                      Contact
                    </li>
                    <li class="menu-text" style="font-weight:100;padding-bottom:0;">
                      <p style="margin-bottom:0;">
                        <span >China: </span>19D Rongjiang Building, Liu Malu, Taojin, Guangzhou, China
                      </p>
                      <p> 
                        P: <a style="padding:0;color:inherit;display:inline;" href="tel:008683520905">(+86) 8352 0905</a>
                        <br />
                        <!-- M: <a style="padding:0;color:inherit;display:inline;" href="tel:8618520415511">(+86)185-2041-5511</a>
                        <br /> -->
                        E: <a style="padding:0;color:inherit;display:inline;" href="mailto:operator@gzone1.com">operator@gzone1.com</a>
                      </p>
                   
                    </li>
                    <li class="menu-text" style="font-weight:100;padding-top:0;">
                      <p style="margin-bottom:0;">
                        <span>Cairo: </span>
                        12 Ahram St Elmoqqattam , Cairo , Egypt
                      </p>
                      <p> 
                        P: <a style="padding:0;color:inherit;display:inline;" href="tel:00201096222212">002-01096222212</a>
                        <br />
                        <!-- M: <a style="padding:0;color:inherit;display:inline;" href="tel:8618520415511">(+86)185-2041-5511</a>
                        <br /> -->
                        E: 
                        <a style="padding:0;color:inherit;display:inline;" href="mailto:sales@gzone1.com">sales@gzone1.com</a>/ 
                        <a style="padding:0;color:inherit;display:inline;" href="mailto:amr@gzone1.com">amr@gzone1.com</a>
                      </p>
                      
                    </li>
                  </ul>
                </div>
                <!-- <div class="cell">
                  <ul class="menu vertical padding-bottom-1">
                    <li class="menu-text" style="font-weight:100;">
                      <p> 
                        P: <a style="padding:0;color:inherit;display:inline;" href="tel:008683520905">(+86) 8352 0905</a>
                        <br />
                        E: <a style="padding:0;color:inherit;display:inline;" href="mailto:operator@gzone1.com">operator@gzone1.com</a>
                      </p>
                    </li>
                  </ul>
                </div> -->

                
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="footer-bottom" class="grid-container full padding-top-1">
      <div class="grid-container">
        <div class="grid-x grid-padding-x grid-padding-y">
          <div class="cell large-3">
            <p style="font-size: 13px;">
              Copyright © {{(new Date()).getFullYear()}} OneBuy. All Rights Reserved.
            </p>
          </div>
          <div class="cell large-9">
            <div class="" style="">
                <div class="item float-right radius">
                <img src="@/assets/images/partner1.jpg" width="160"  style="max-height:70px;" />
              </div>
              <div class="item float-right radius">
                <img src="@/assets/images/partner2.jpg" width="160" style="max-height:70px;" />
              </div>
              <div class="item float-right radius">
                <img src="@/assets/images/partner3.jpg" width="160" style="max-height:70px;" />
              </div>
              <div class="item float-right radius">
                <img src="@/assets/images/partner4.jpg" width="160" style="max-height:70px;" />
              </div>
            </div>

            <span class="float-right padding-right-1" style="font-size: 13px;"
              >Partners</span
            >
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import dataService from "@/store.catalog/services/main-service.js";

export default {
  name: "footerView",
  data() {
    return {
      menuList: [],
      currentCatalogId: null,
      mainMenuList: []
    }
  },
  components: {
    // "slider-carousel": () => import("@/app/components/slider-carousel"),
  },
  mixins: [require("@/app/mixins/foundation")],
  created () {
    this.initMainCatalogs();
  },
  methods: {
    initMainCatalogs(){
      let _this = this;
      return dataService.getMainCategories().then(function(response) {
        var itemsOrdered = response.data.sort((a, b) => a.sorting - b.sorting);

        _this.menuList = itemsOrdered || [];


        if (_this.menuList && _this.menuList.length > 0) {
          _this.currentCatalogId = _this.menuList[0].id;
        }
      });
    }
  },
};
</script>

<style lang="scss">
@import "./../../assets/sass/settings/settings";

footer {
  background: $white;
}
#footer-bottom {
  background: $white;;
}
</style>
